import 'bootstrap/dist/css/bootstrap.min.css';
//import BgImage from './img/paper-background.png';

import './App.css';
import Icons from './Icons';

import 'aos/dist/aos.css';
import AOS from 'aos';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import TopNav from './TopNav';
import ProjectCarousel from './ProjectCarousel';
import TypewriterText from './TypewriterText';

import UserAddIcon from './img/icons/user-add.png';




function About() {
  const navigate = useNavigate();
  const [typingComplete, setTypingComplete] = useState(false);

  const phrases = [
    'Product Designer',
    'UX/UI Designer',
    'Software Developer',
    'Creative Technologist'
  ];

  useEffect(() => {
    AOS.init({
      duration: 1250,
      once: true,
    });
  }, []);

  return (
    <div className="d-flex justify-content-center flex-column bg-main-dark pb-5">
      <TopNav />
      <div className="my-2">
        <div className="container px-5">
          <div className="row">
            <div className="col-lg-7 p-4 d-flex align-items-center">
              <div>
                <h1 className="about-header" data-aos="fade" data-aos-delay="300" data-aos-duration="2500">JM</h1>
                <h1 className="about-header grey" data-aos="fade" data-aos-delay="300" data-aos-duration="2500">CRAWFORD</h1>
                <div data-aos="fade" data-aos-delay="300" data-aos-duration="5000">
                  <TypewriterText phrases={phrases} onComplete={() => setTypingComplete(true)} />
                </div>
                
                {/* <p className="about-subheader-2 mb-1" data-aos="fade" data-aos-delay="300" data-aos-duration="5500">LEXINGTION, KY</p> */}
                <p className="about-body pt-2" data-aos="fade" data-aos-delay="300" data-aos-duration="6000">My mission is to help individuals and organizations craft engaging, meaningful, and enduring connections with their audiences through practical and visually stunning design and creative solutions.</p>
                {/* <p className="about-body" data-aos="fade" data-aos-delay="300" data-aos-duration="6000">I’m a creative technologist with a foundation in graphic design, systems thinking, and visual culture. My approach blends research, strategy, and interactive experiences to build brands, interfaces, and experiences that are clear, purposeful, and performance-driven.</p> */}

                {/* <p className="about-body" data-aos="fade" data-aos-delay="300" data-aos-duration="6000">With degrees in Graphic Design, Digital Media, and Art History, I bring a multidisciplinary lens to every challenge - combining user insight, research, and design thinking to craft experiences that connect and endure.</p> */}

                <div className="d-flex gap-3 flex-column flex-sm-row mt-2" data-aos="fade" data-aos-delay="300" data-aos-duration="6000">
                  <motion.button
                    className="button-4 button-dark d-flex align-items-center justify-content-center"
                    style={{ padding: '12px 20px' }}
                    onClick={() => navigate('/portfolio')}
                    initial={{ scale: 1 }}
                    animate={typingComplete ? {
                      scale: [1, 1.08, 1, 1.08, 1],
                    } : {}}
                    transition={{
                      delay: 0.5,
                      duration: 1,
                      ease: "easeInOut"
                    }}
                  >
                    <span style={{ fontSize: '16px', marginRight: '8px' }}>→</span>
                    View Portfolio
                  </motion.button>
                  <motion.button
                    className="button-4 d-flex align-items-center justify-content-center"
                    style={{ padding: '12px 20px' }}
                    onClick={() => window.location.href = '/contact'}
                    initial={{ scale: 1 }}
                    animate={typingComplete ? {
                      scale: [1, 1.08, 1, 1.08, 1],
                    } : {}}
                    transition={{
                      delay: 1.8,
                      duration: 1,
                      ease: "easeInOut"
                    }}
                  >
                    <img src={UserAddIcon} alt="Let's Connect" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                    Let's Connect
                  </motion.button>
                </div>
                {/* <div className="d-flex justify-content-start">
                  <button className="mt-5 ms-4 p-2 bg-dark text-light border border-secondary rounded">Resume</button>
                  <button className="mt-5 ms-4 p-2 bg-dark text-light border border-secondary rounded">Extended Resume</button>
                </div> */}
              </div>
            </div>
            <div className="col-lg-5 col-12 d-flex flex-column align-items-center justify-content-center">
              <div data-aos="fade" data-aos-delay="500" data-aos-duration="2000" style={{ width: '100%' }}>
                <ProjectCarousel />
              </div>
            </div>
          </div>

        {/* Animate About section title and body to fade in after hero using Framer Motion */}
        <div className="section-2 my-5">
          <div className="content-2">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 2.2, duration: 0.7, ease: 'easeOut' }}
              className="top"
            >
              <b className="secondary-headline text-center">About</b>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 2.5, duration: 0.7, ease: 'easeOut' }}
              className="paragraph-2 text-center"
            >
              {`I’m a multidisciplinary designer and software developer based in Lexington, KY. My experience spans graphic design, branding, printmaking, research, UX/UI design, interaction design, and software development. I thrive on helping clients capture the authentic essence of their brand, product, or service - turning ideas into visually compelling, functional designs.
              `}
            </motion.div>
          </div>
        </div>

        <div className="section-2 my-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-4 mb-4">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 3.2, duration: 0.7, ease: 'easeOut' }}
                className="feature-card"
              >
                <div className="feature-icon-wrapper mb-3">
                  <div className="feature-icon">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                      <path d="M24 42L8 26C5 23 4 19 5 15C6 11 9 8 13 7C17 6 21 7 24 10C27 7 31 6 35 7C39 8 42 11 43 15C44 19 43 23 40 26L24 42Z" 
                            stroke="var(--color-gray)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    </svg>
                  </div>
                </div>
                <div className="top mb-3">
                  <b className="secondary-headline text-center">Values</b>
                </div>
                <div className="paragraph text-center">
                  {`My values as a designer and developer are anchored in thoughtful user-centric design, utilizing in-depth research, iterative design, and effective communication to produce work that connects with audiences to bring meaningful and impactful experiences to products and brands.`}
                </div>
              </motion.div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 4.0, duration: 0.7, ease: 'easeOut' }}
                className="feature-card"
              >
                <div className="feature-icon-wrapper mb-3">
                  <div className="feature-icon">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path d="M24 16C16 16 10 24 10 24s6 8 14 8 14-8 14-8-6-8-14-8z" stroke="var(--color-gray)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="24" cy="24" r="4" stroke="var(--color-gray)" strokeWidth="2.5" fill="none"/>
                    </svg>
                  </div>
                </div>
                <div className="top mb-3">
                  <b className="secondary-headline text-center">Vision</b>
                </div>
                <div className="paragraph text-center">
                  {`I am committed to continuously learning, growing, and adapting to industry standards as well as the unique demands of each client and project I undertake. I am a hands-on creative leader with the ability to contribute to projects from discovery and design to development and production.`}
                </div>
              </motion.div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 4.8, duration: 0.7, ease: 'easeOut' }}
                className="feature-card"
              >
                <div className="feature-icon-wrapper mb-3">
                  <div className="feature-icon">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                      <circle cx="24" cy="24" r="18" stroke="var(--color-gray)" strokeWidth="2.5" fill="none"/>
                      <circle cx="24" cy="24" r="3" fill="var(--color-gray)"/>
                      <path d="M24 6V18M24 30V42" stroke="var(--color-gray)" strokeWidth="2.5" strokeLinecap="round"/>
                      <path d="M6 24H18M30 24H42" stroke="var(--color-gray)" strokeWidth="2.5" strokeLinecap="round"/>
                      <circle cx="24" cy="24" r="8" stroke="var(--color-gray)" strokeWidth="1.5" fill="none"/>
                    </svg>
                  </div>
                </div>
                <div className="top mb-3">
                  <b className="secondary-headline text-center">Niche</b>
                </div>
                <div className="paragraph text-center">
                  {`My niche is in completing end-to-end interactive digital products, working seamlessly across all domains of the product lifecycle. I leverage custom internal tools for deep research, rapid discovery, and frontend engineering to deliver meaningful user experiences from concept through production.`}
                </div>
              </motion.div>
            </div>
          </div>
        </div>

       {/* 
          <div className="content-2">
              <b className="secondary-headline text-center">Tools</b>
          </div>
      

          <div className="row mt-0 pt-0 d-flex justify-content-center ">
            <div className="col-12" data-aos="fade" data-aos-delay="500" data-aos-duration="2500">
              <Icons />
            </div>
          </div>       
        */}

          {/* <div className="row mt-5 pt-3">
            <div className="col-12">
              <h2 className="text-second text-center mb-4">Skills</h2>
              <div className="skills-container d-flex flex-wrap justify-content-center gap-2 mb-4">
                
                <span className="skill-pill">User research</span>
                <span className="skill-pill">Ethnographic analysis</span>
                <span className="skill-pill">Affinity mapping</span>
                <span className="skill-pill">Empathy mapping</span>
                <span className="skill-pill">Persona development</span>
                <span className="skill-pill">Stakeholder mapping</span>
                <span className="skill-pill">Ecosystem mapping</span>
                <span className="skill-pill">Interaction design</span>
                <span className="skill-pill">System design</span>
                <span className="skill-pill">Wireframing</span>
                <span className="skill-pill">UI Prototyping</span>
                <span className="skill-pill">UI design + development</span>
                <span className="skill-pill">User Interface (UI)</span>
                <span className="skill-pill">User Experience (UX)</span>
                <span className="skill-pill">User-centric Design</span>
                <span className="skill-pill">Accessibility</span>

               
                <span className="skill-pill">Front-end development</span>
                <span className="skill-pill">Back-end development</span>
                <span className="skill-pill">Full-stack development</span>
                <span className="skill-pill">API Development</span>
                <span className="skill-pill">Responsive Design</span>
                <span className="skill-pill">Web Design + Developement</span>
                <span className="skill-pill">Database Architecture</span>

                
                <span className="skill-pill">Layout + Grid Design</span>
                <span className="skill-pill">Typographic Design</span>
                <span className="skill-pill">Editorial design</span>
                <span className="skill-pill">Visual Storytelling</span>
                <span className="skill-pill">Digital + Print production</span>
                <span className="skill-pill">Creative direction</span>
                <span className="skill-pill">Visual strategy</span>

              
                <span className="skill-pill">Illustration</span>
                <span className="skill-pill">Photography</span>
                <span className="skill-pill">Photo editing</span>
                <span className="skill-pill">Screen printing</span>

                
                <span className="skill-pill">Design + Business strategy</span>
                <span className="skill-pill">Concept development</span>
                <span className="skill-pill">Client collaboration</span>
                <span className="skill-pill">Communication</span>
                <span className="skill-pill">Public speaking</span>
                <span className="skill-pill">Remote team collaboration</span>
                <span className="skill-pill">Team development</span>
                <span className="skill-pill">Leadership</span>
                <span className="skill-pill">Project management</span>
                <span className="skill-pill">Planning</span>
                <span className="skill-pill">Time management</span>
                <span className="skill-pill">Problem solving</span>
                <span className="skill-pill">Critical thinking</span>
                <span className="skill-pill">Creative writing</span>
                <span className="skill-pill">Copywriting</span>
                <span className="skill-pill">Interdisciplinary research</span>
                <span className="skill-pill">Historical contextualization</span>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
}

export default About;




